<template lang="pug">
  div
    .row(v-if="isBhpEnvironment")
        .col-md-12(v-if="loyaltyDetails.details")
            small.block.text-center.m-y-sm eCard Details

        .col-md-12.table-responsive(v-if="loyaltyDetails.details")
            table.m-b-0
              tbody
                  tr(v-if="loyaltyDetails.details.customerName")
                    td(colspan=3) {{ loyaltyDetails.details.customerName }}
                  tr(v-if="loyaltyDetails.details.cardNumber")
                    td eCard No.
                    td :
                    td.text-right {{ loyaltyDetails.details.cardNumber }}
                  tr(v-if="loyaltyDetails.details.merchantNo")
                    td Merchant No.
                    td :
                    td.text-right {{ loyaltyDetails.details.merchantNo }}
                  tr(v-if="loyaltyDetails.details.refNo")
                    td Reference No.
                    td :
                    td.text-right {{ loyaltyDetails.details.refNo }}
                  tr(v-if="loyaltyDetails.details.openingPoints")
                    td Points Balance
                    td :
                    td.text-right {{ loyaltyDetails.details.openingPoints }} pts
                  tr(v-if="loyaltyDetails.details.issuedPoints")
                    td Points Earned
                    td :
                    td.text-right {{ loyaltyDetails.details.issuedPoints }} pts
                  tr(v-if="loyaltyDetails.details.pointsBalance")
                    td New Balance
                    td :
                    td.text-right {{ loyaltyDetails.details.pointsBalance }} pts
                  tr(v-if="loyaltyDetails.details.pointsExpiry")
                    td ePoints Expiry
                    td :
                    td.text-right
                      div(v-for="epointsExpiry in loyaltyDetails.details.pointsExpiry")
                        div {{ epointsExpiry.val }} pts - {{ epointsExpiry.expiry }}

    .row(v-else)
        template(v-if="loyaltyDetails")
          div.block.text-center Loyalty Details
            .col-md-12
                table.m-b-0.text-center
                  tbody
                      tr
                        td(colspan=3) No loyalty card

</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import Unleash from '@js/plugins/unleash';

export default {
    mixins: [receiptMixin],
    computed: {
        ...mapGetters('transactionPostgres', ['loyaltyDetails']),

        isBhpEnvironment() {
            return Auth.metas().environment === 'bhp';
        },
    },

    methods: {
        formatLoyaltyId(loyaltyId) {
            return '*'.repeat(11) + String(loyaltyId.split('=')[0]).slice(-4);
        },
    },
};
</script>

<style lang="scss" scoped>
table {
    width: 100%;
}

table tr td {
    vertical-align: top !important;
}

.col-flex {
    display: flex;
    border: 2px solid #000;
    padding: 10px;
    border-radius: 10px;
}
</style>
